<template>
    <div class="single index uk-first-section-xlarge-padding">
        <div class="uk-section">
            <div class="uk-background-gradient-7 uk-height-viewport uk-position-top"></div>
            <div class="uk-container">
                <div class="uk-grid uk-grid-large uk-child-width-1-1 uk-child-width-expand@m" uk-grid>
                    <div class="uk-width-expand@m uk-padding-large-right@m">
                        <div class="top uk-margin-large-bottom">
                            <div class="back">
                                <a :href="return_url" class="uk-link uk-link-primary">
                                    <span class="uk-icon" uk-icon="chevron-left"></span>
                                    <span>{{ $t("message.button_to_careers")}}</span>
                                </a>
                            </div>
                            <h1 class="uk-margin-small-top uk-h2">{{ $parent.job.title }}</h1>
                            <div class="uk-margin-large-bottom">
                                <span v-for="(item, index) in locations" :key="index" class="uk-badge">{{ item }}</span>
                            </div>
                            <div class="uk-flex uk-flex-between uk-flex-wrap uk-flexgap-medium">
                                <a :href="$parent.job.apply_url" target="_blank" class="uk-button uk-button-indigo">{{ $t("message.apply_now")}}</a>
                                <div class="uk-flex uk-flex-middle">
                                    <div class="uk-grid uk-grid-small" uk-grid>
                                        <div>
                                            <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encoded_url"
                                                class="uk-button-social uk-button-social-facebook"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: facebook; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + encoded_url"
                                                class="uk-button-social uk-button-social-linkedin"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: linkedin; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'https://twitter.com/intent/tweet?url=' + encoded_url + '&text=' + encoded_title"
                                                class="uk-button-social uk-button-social-twitter"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: twitter; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'mailto:?subject=' + encoded_title + '&body=Hello,%0A %0A I found this at datarobot.com and thought you might be interested. Take a look here: ' + encoded_url + '%0A %0A Thank you.'"
                                                class="uk-button-social uk-button-social-email"
                                                rel="nofollow" target="_blank">
                                                <span uk-icon="icon: mail; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="content">
                            <div class="job-description uk-text-default uk-text-font-default" v-if="decodeEntities($parent.job.JobDescription)" v-html="decodeEntities($parent.job.JobDescription)"></div>
                            <div class="uk-flex uk-flex-between uk-flex-wrap uk-flexgap-medium">
                                <a :href="$parent.job.apply_url" target="_blank" class="uk-button uk-button-indigo">{{ $t("message.apply_now")}}</a>
                                <div class="uk-flex uk-flex-middle">
                                    <div class="uk-grid uk-grid-small" uk-grid>
                                        <div>
                                            <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encoded_url"
                                                class="uk-button-social uk-button-social-facebook"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: facebook; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + encoded_url"
                                                class="uk-button-social uk-button-social-linkedin"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: linkedin; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'https://twitter.com/intent/tweet?url=' + encoded_url + '&text=' + encoded_title"
                                                class="uk-button-social uk-button-social-twitter"
                                                onclick="shareThis(this.href); return false;" rel="nofollow" target="_blank">
                                                <span uk-icon="icon: twitter; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                        <div>
                                            <a :href="'mailto:?subject=' + encoded_title + '&body=Hello,%0A %0A I found this at datarobot.com and thought you might be interested. Take a look here: ' + encoded_url + '%0A %0A Thank you.'"
                                                class="uk-button-social uk-button-social-email"
                                                rel="nofollow" target="_blank">
                                                <span uk-icon="icon: mail; ratio: 0.75"></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="uk-width-large@m uk-box-sizing-content">
                        <div class="uk-flex uk-flexgap-medium uk-flex-column uk-flex-row@s uk-flex-column@m">
                            <div class="department-info uk-padding-medium uk-border-rounded uk-background-muted uk-flex-1" v-if="is_show_dept_description">
                                <div class="uk-h5">{{ deptinfo.post_title }}</div>
                                <div>{{ deptinfo.post_content }}</div>
                            </div>
                            <div class="core-values uk-light uk-padding-medium uk-border-rounded uk-flex uk-flex-column uk-background-cover uk-flex-1" style="min-height: 435px; background-color: #000;">
                                <div class="uk-h5">{{ $t("message.core_values") }}</div>
                                <div class="uk-text-caption">{{ $t("message.core_values_text") }}</div>
                                <div class="uk-margin-auto-top">
                                    <a :href="url_base + 'about-us'" class="uk-button uk-button-primary uk-width-1-1">{{ $t("message.learn_about_dr") }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import JobItem from './JobItem.vue';

  export default {
    name: 'JobPost',
    props: ['id', 'department', 'deptinfo', 'locations'],
    components: {
      'job-item': JobItem,
    },
    data() {
      return {
        referer: window.careers_data.return_url,
      }
    },
    computed: {
      return_url: function(){
        let locale = window.careers_data.locale === 'ja' ? 'jp' : '';
        let basePath = locale ? `/${locale}` : ''; // Only add slash if locale is not empty
        return `${window.location.origin}${basePath}/careers`;
	  },
      url_base: function(){
        return window.careers_data.locale === 'en' ? '/' : '/jp/';
      },
      isMobile: function(){
        return this.windowWidth < 1024
      },
      is_show_dept_description: function(){
        return this.deptinfo.dept_ID === this.department;
      },
      encoded_url: function() {
        return encodeURIComponent(window.location.href);
      },
      encoded_title: function() {
        return encodeURIComponent(document.querySelector('meta[property="og:title"]').content);
      }
    },
    methods: {
      decodeEntities: function(encodedString) {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value;
      },
      handleResize: function(event){
        this.windowWidth = event.currentTarget.innerWidth;
      },
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize);
    }
  };
</script>
